import React from 'react';
import Storypoint from './Storypoint';

export const StorypointListView = ({
  storypoints = [],
  controls = false,
  storyId,
  exhibitionId,
}) => (
  <div className="storypoint-list-wrapper">
    <div className="storypoint-list">
      <div className="storypoints ui horizontal list inverted">
        {storypoints.map(
          storypoint =>
            storypoint._id && (
              <div key={storypoint._id} className="item">
                <Storypoint
                  exhibitionId={exhibitionId}
                  storypoint={storypoint}
                  controls={controls}
                  storyId={storyId}
                />
              </div>
            ),
        )}
      </div>
    </div>
  </div>
);

const StorypointList = StorypointListView;

export default StorypointList;
